import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {QuestionReport} from '../incase-domain/analytics';
import {roomSelector} from '../store/selectors/roomRunFile.selectors';
import {questionReportsSelector} from '../store/selectors/analytics.selectors';
import {fetchQuestionReportAction} from '../store/actions/analytics.actions';
import {socket} from '../util/socket';

export function useQuestionReportData(questionElementId: string | undefined): QuestionReport | undefined {
    const dispatch = useDispatch();
    const room = useSelector(roomSelector);
    const questionReports = useSelector(questionReportsSelector);

    const inRoom = !!room.roomId;

    const [liveReport, setLiveReport] = useState<QuestionReport | undefined>();

    useEffect(() => {
        if (!inRoom || !questionElementId || !socket) {
            return undefined;
        }

        const eventName = `questionReport-${questionElementId}`;
        const handler = (report: QuestionReport): void => setLiveReport(report);

        socket.emit('subscribeQuestionReport', {
            questionId: questionElementId,
            roomRunfileId: room.roomRunFileId,
        });
        socket.on(eventName, handler);

        return () => {
            socket?.emit('unsubscribeQuestionReport', {questionId: questionElementId});
            socket?.off(eventName, handler);
        };
    }, [inRoom, questionElementId, room.roomRunFileId]);

    useEffect(() => {
        if (inRoom || !questionElementId) return;
        dispatch(fetchQuestionReportAction(questionElementId));
    }, [inRoom, questionElementId, dispatch]);

    return inRoom ? liveReport : questionReports.find((qr) => qr.elementId === questionElementId);
}
